// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const WebhookSignatureVerification = {
    hmac: (value) => {
        return Object.assign(Object.assign({}, value), { type: "hmac", _visit: function (visitor) {
                return FernIr.WebhookSignatureVerification._visit(this, visitor);
            } });
    },
    asymmetric: (value) => {
        return Object.assign(Object.assign({}, value), { type: "asymmetric", _visit: function (visitor) {
                return FernIr.WebhookSignatureVerification._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "hmac":
                return visitor.hmac(value);
            case "asymmetric":
                return visitor.asymmetric(value);
            default:
                return visitor._other(value);
        }
    },
};
